<template>
  <div class="approval-checklist-detail">
    <approval-search
      :show-btn="true"
      :show-batch-btn="showBatchBtn"
      :status="status"
      :filter="filter"
      :show-initiate-btn="showInitiateBtn"
      :show-print-btn="showPrintBtn && documentConfigId===BILL_PAYMENT.code"
      :view-source="viewSource"
      :type="type"
      :document-config-id="documentConfigId"
      :per-config-name.sync="perConfigName"
      :grid-refresh-id.sync="gridRefreshId"
      style="min-width: 1200px;"
      @toQuery="toQuery"
      @toBatchApproval="toBatchApproval"
      @toBatchReject="toBatchReject"
      @toInitiate="toInitiate"
      @toPrint="toPrint"
      @toCancel="toCancel"
    />
    <approval-list-grid
      ref="approvalListGrid"
      :config-module="configModule"
      :type="type"
      :document-config-id-prop="documentConfigId"
      :per-config-name="perConfigName"
      :grid-refresh-id="gridRefreshId"
      :total="filter.total"
      :status="status"
      :row-data="rowData"
      @toQuery="toQuery"
      @changeSelected="changeSelected"
    />
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
    />
    <!-- 发起审批弹窗-->
    <el-dialog
      :visible.sync="initiateDialog.visible"
      :title="$t('CargoMsg.Cargo_InitiateApproval')"
      width="450px"
      custom-class="cargo-form-dialog"
    >
      <el-form label-width="70px" label-position="left" style="margin-left: auto">
        <el-form-item :label="$t('CargoMsg.Cargo_InitiateForm')">
          <cargo-advance-select
            tag-value="code"
            :static-options="initiateDialog.workflowTypes"
            @parentCallBack="p=>{initiateDialog.formId=p.value}"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="initiateHandleClose">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      @selectedTemplate="updatePrintField"
    />
  </div>
</template>

<script>
import {
  batchCancel,
  workflowActionBatch,
  workflowPendingList,
  workflowSelfList
} from '@/api/workflow'
import { getLoading } from '@/utils/utilBaseElement'
import ApprovalListGrid from '@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/approvalListGrid'
import ApprovalSearch from '@/components/Cargo/Common/Wrokflow/approvalSearch'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import {
  BILL_PAYMENT
} from '@/class/cargo/model/parameters/WorkflowConstants'
import GlobalDialog from '@/utils/GlobalDialog'
import billPaymentCreatorDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentCreatorDialog'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { uploadHasPrint } from '@/api/clearing/billPayment'

export default {
  name: 'ApprovalChecklistDetail',
  components: { ApprovalSearch, ApprovalListGrid, batchSubmitOrApproveDialog, billPaymentCreatorDialog, cargoAdvanceSelect, cargoTemplateSelectorDialog },
  props: {
    configModule: { type: String, default: '' },
    status: { type: Number, default: 0 },
    type: { type: String, default: '' },
    // CARGO-33121 7.管理权限内容，bpm高级设置（管理员仅可查看此分公司下的此表单所有人发起的审批（审批事项清单——我处理的——全部），仅可查看不可做任何操作。）
    queryAll: { type: Boolean, default: false },
    // CARGO-33389 8.审批事项清单+首页快捷方式功能迁移（新增“创建”功能键，即【发起】按钮）
    showInitiateBtn: { type: Boolean, default: false },
    // CARGO-33559 10.审批凭证打印功能（审批事项——审批事项清单——我发起的——已完成 页签 增加打印按钮）
    showPrintBtn: { type: Boolean, default: false },
    // 来源【initiateAll：我发起的-全部 initiateProcessing：我发起的-处理中 initiateCompleted：我发起的-已完成 initiateRevoked：我发起的-已撤销 handleAll：我处理的-全部 handleTodo：我处理的-待处理 handleCompleted：我处理的-已完成】
    viewSource: { type: String, default: '' },
    // 是否选择表单类型
    documentConfigId: { type: Number, default: 0 }
  },
  data() {
    return {
      selectedRows: [],
      loading: null,
      filter: {
        total: 0,
        startDate: '',
        lastModified: '',
        officeIdList: [],
        workflowName: '',
        approvalDate: '',
        approveIdList: [],
        state: null,
        approvalTemplate: '',
        documentConfigIdList: [],
        documentProcessNo: '',
        // CARGO-33121 7.管理权限内容，bpm高级设置（管理员仅可查看此分公司下的此表单所有人发起的审批（审批事项清单——我处理的——全部），仅可查看不可做任何操作。）
        queryAll: this.queryAll,
        applicationDimensions: [],
        viewSource: this.viewSource,
        requireCargoColumndefs: false
      },
      rowData: [],
      records: [],
      processDetail: [],
      documentConfigName: '',
      workflowName: '',
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      initiateDialog: {
        visible: false,
        workflowTypes: [BILL_PAYMENT],
        formId: null
      },
      billPaymentCreatorDialog: null,
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLING_LIST_UUID: []
        }
      },
      perConfigName: '',
      gridRefreshId: 0,
      BILL_PAYMENT
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    applyDialogTitle() {
      return this.type === 'look' ? this.$t('CargoMsg.Cargo_ReviewTheApprovalProcess') : this.$t('CargoMsg.Cargo_Approving')
    },
    showBatchBtn() {
      return this.type === 'approve' && this.status === 0
    }
  },
  watch: {
    queryAll: {
      immediate: true,
      handler() {
        this.filter.queryAll = this.queryAll
      }
    },
    documentConfigIdProp: {
      handler() {
        console.log('documentConfigIdProp:', this.documentConfigIdProp)
      }
    }
  },
  beforeDestroy() {
    if (this.billPaymentCreatorDialog) {
      this.billPaymentCreatorDialog.instance.destroySelf()
    }
    // if (this.billPaymentDialog.dialog) {
    //   this.billPaymentDialog.dialog.instance.destroySelf()
    // }
  },
  methods: {
    init(documentProcessNo = '') {
      this.filter = {
        total: 0,
        startDate: '',
        lastModified: '',
        officeIdList: [],
        workflowName: '',
        approvalDate: '',
        approveIdList: [],
        state: null,
        approvalTemplate: '',
        documentConfigIdList: [],
        documentProcessNo: documentProcessNo,
        queryAll: this.queryAll,
        applicationDimensions: [],
        viewSource: this.viewSource,
        requireCargoColumndefs: false
      }
      // CARGO-35929 【BPM】审批事项清单筛选条件优化
      if (this.status !== -1 || documentProcessNo) {
        const showDetail = !!documentProcessNo
        this.toQuery(showDetail)
      }
    },
    toQuery(showDetail = false) {
      this.filter.pageNum = this.$refs.approvalListGrid.filter.pageNum
      this.filter.pageSize = this.$refs.approvalListGrid.filter.pageSize
      // 左边菜单是否选中【表单类型】
      if (this.documentConfigId) {
        this.filter.documentConfigIdList = [this.documentConfigId]
        this.filter.requireCargoColumndefs = true
      }
      // 转换时间数据
      const params = this.filter
      WorkflowUtil.changeFilter(params)
      // 若不是全部页面，则使用具体页签的状态参数
      if (this.status !== -1) {
        params.state = this.status
      }
      if (this.type === 'look') {
        this.loading = getLoading('approval-checklist-detail')
        workflowSelfList(this.filter).then(res => {
          params.total = res.data.total
          this.rowData = res.data.list
          if (showDetail && this.rowData && this.rowData.length > 0) {
            this.$refs.approvalListGrid.onRowDoubleClicked({ data: this.rowData[0] })
          }
          this.applyCloseAndRefresh(params.total)
        }).finally(() => {
          this.loading.close()
        })
      }
      if (this.type === 'approve') {
        this.loading = getLoading('approval-checklist-detail')
        // CARGO-33121 7.管理权限内容，bpm高级设置（管理员仅可查看此分公司下的此表单所有人发起的审批（审批事项清单——我处理的——全部），仅可查看不可做任何操作）
        // if (this.status === -1) {
        //   params.queryAll = true
        // }
        workflowPendingList(this.filter).then(res => {
          params.total = res.data.total
          this.rowData = res.data.list
          if (showDetail && this.rowData && this.rowData.length > 0) {
            this.$refs.approvalListGrid.onRowDoubleClicked({ data: this.rowData[0] })
          }
          this.applyCloseAndRefresh(params.total)
          if (this.filter.state === 0) {
            const approvalMattersRoutes = this.$store.state.permission.routes.filter(route => route.path === '/ApprovalMatters')
            if (approvalMattersRoutes && approvalMattersRoutes.length > 0) {
              approvalMattersRoutes[0].badgeCount = res.data.total
            }
          }
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    applyCloseAndRefresh(total) {
      this.$emit('reloadCount', total)
    },
    // 批量同意
    toBatchApproval() {
      this.batchApprove(this.$t('CargoMsg.Cargo_AgreeToTheApproval'), 7001)
    },
    // 批量拒绝
    toBatchReject() {
      this.batchApprove(this.$t('CargoMsg.Cargo_RejectApproval'), 7002)
    },
    // 批量操作
    batchApprove(actionName, actionType) {
      const selectRows = this.getSelectedRows()
      if (selectRows === null) {
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [actionName]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const params = []
        for (const row of selectRows) {
          const param = {
            documentConfigId: row.documentConfigId,
            docId: row.docId,
            docNo: row.billPaymentNo,
            actionType: actionType,
            documentProcessId: row.documentProcessId,
            documentProcessNo: row.documentProcessNo,
            applicationDimension: row.applicationDimension
          }
          params.push(param)
        }
        this.loading = getLoading('approval-checklist-detail')
        workflowActionBatch(params).then(res => {
          if (!res.data || res.data.length === 0) {
            this.$message.success(actionName + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          } else {
            this.batchSubmitOrApproveDialog.visible = true
            this.batchSubmitOrApproveDialog.rowData = res.data
          }
          this.toQuery()
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => { })
    },
    changeSelected(list) {
      this.selectedRows = list
    },
    // 获取待审核的勾选数据
    getSelectedRows() {
      const selectedRows = this.selectedRows
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return null
      }
      return selectedRows
    },
    // 发起
    toInitiate() {
      this.initiateDialog.visible = true
    },
    // 真正发起
    handleSubmit() {
      if (!this.initiateDialog.formId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_InitiateForm'))
        return null
      }
      // 发起付款申请单
      if (BILL_PAYMENT.code === this.initiateDialog.formId) {
        this.toCreatePayment()
      }
    },
    // 创建付款申请
    toCreatePayment() {
      if (!this.billPaymentCreatorDialog) {
        const propsData = { viewSource: 'billPaymentNew' }
        this.billPaymentCreatorDialog = new GlobalDialog(billPaymentCreatorDialog, { propsData })
        const { instance } = this.billPaymentCreatorDialog
        instance.createBillPayment({ step: 'step1', title: this.$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees') })
        instance.$on('cancel', this.initiateHandleClose)
        instance.$on('saveSuccess', this.toQuery)
      } else {
        this.billPaymentCreatorDialog.instance.visible = true
      }
    },
    initiateHandleClose() {
      this.initiateDialog.visible = false
    },
    // 打印
    toPrint() {
      const chooseRows = this.$refs.approvalListGrid.getSelections()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventToApprove'))
        return
      }
      // 相同的审批模板，才允许打印
      if (new Set(chooseRows.map(item => item.documentConfigId)).size > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectApprovalWithSameTemplate'))
        return
      }
      const params = {}
      // 审批模板【付款申请】
      if (BILL_PAYMENT.code === chooseRows[0].documentConfigId) {
        if (chooseRows.length === 1) {
          params.BILLPAYMENT_UUID = chooseRows[0].docId
          params.BILL_PAYMENT_UUID = chooseRows[0].docId
          this.templateSelectorDialog.data = params
          this.templateSelectorDialog.category = 'BILLPAYMENT'
          this.templateSelectorDialog.visible = true
        } else {
          const keys = []
          for (const item of chooseRows) {
            if (item.docId && keys.indexOf(item.docId) < 0) {
              keys.push(item.docId)
            }
          }
          params.BILL_PAYMENT_UUID_LIST = keys
          params.printSource = DocumentConstants.BATCH_PRINT_FKSQ.code
          this.templateSelectorDialog.data = params
          this.templateSelectorDialog.category = 'BILLPAYMENT_LIST'
          this.templateSelectorDialog.visible = true
        }
      }
    },
    // 取消
    toCancel() {
      const selectRows = this.getSelectedRows()
      if (selectRows === null) {
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureToDo', [this.$t('CargoMsg.Cargo_Cancel')]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        // 构建bpm请求参数
        const paramsBpm = []
        for (const row of selectRows) {
          const paramBpm = {
            docId: row.docId,
            documentProcessNo: row.documentProcessNo
          }
          paramsBpm.push(paramBpm)
        }
        this.loading = getLoading()
        batchCancel(paramsBpm).then(res => {
          if (!res.data || res.data.length === 0) {
            this.$message.success(this.$t('CargoMsg.Cargo_Cancel') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
          } else {
            this.batchSubmitOrApproveDialog.visible = true
            this.batchSubmitOrApproveDialog.rowData = res.data
          }
          this.loading.close()
          this.toQuery()
        }).catch(() => { this.loading.close() })
      })
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      } else {
        Object.assign(keys, this.templateSelectorDialog.data.BILL_PAYMENT_UUID_LIST)
      }
      this.loading = getLoading()
      uploadHasPrint(keys)
        .then(res => {
          if (res.ok && res.data) {
            this.$refs.queryBillPayment.toQueryBillPaymentList()
          }
        }).catch(() => { this.loading.close() }).finally(() => { this.loading.close() })
    }
  }
}
</script>

<style lang="scss" scoped>
.approval-checklist-detail{
  .el-form{
    .el-form-item__content{
      width: 210px;
    }
    .el-date-editor--datetime{
      width: 210px !important;
    }
  }
}
</style>
